import { useEffect, useState } from 'react'
import { useParams, useHistory } from 'react-router'
import moment from 'moment-timezone'
import _ from 'lodash'

//graphql
import gql from 'graphql-tag'
import { useLazyQuery, useMutation, useSubscription } from '@apollo/react-hooks'

//styles
import './Device.css'

// semantic ui react
import {
  Container,
  Icon,
  Header,
  Table,
  Button,
  Modal,
  Message,
  Pagination,
  Grid,
  Input,
  Label,
  Loader,
  Dimmer
} from 'semantic-ui-react'

// graphql
const DEVICE = gql`
query Device ($id: ID!) {
  me {
    id
    device (id: $id) {
      id
      serial
      name
      model
      provisioned
      enabled
      online
      po_number
      purchased_at
      created_at
      description
      meta
      research
      connections {
        id
        ip
        created_at
        destroyed_at
      }
    }
  }
}
`
const DEVICE_LOG = gql`
  query GetLogs ($id: ID!, $page: Int) {
    me {
      id
      device (id: $id) {
        id
        logs (page: $page) {
          edges {
            node {
              id
              level
              label
              event
              message
              meta
              created_at
              updated_at
            }
          }
          page_info {
            has_next_page
            has_previous_page
          }
          total_count
          total_pages
        }
      }
    }
  }
`
const DELETE_DEVICE = gql`
  mutation DeleteDevice ($input: DeleteDeviceInput!) {
    delete_device (input: $input) {
      id
    }
  }
`
const ONLINE_SUBSCRIPTION = gql`
  subscription DeviceOnline {
    device_online {
      device_id
      online
    }
  }
`
const RESET_TOKENS = gql`
  mutation ResetTokens ($input: ResetDeviceTokenInput!) {
    reset_device_token (input: $input) {
      id
    }
  }
`
const UPDATE_DEVICE = gql`
  mutation UpdateDevice ($input: UpdateDeviceInput!) {
    update_device (input: $input) {
      id
    }
  }
`

let labelColors = {
  error: 'red',
  warn: 'yellow',
  info: 'olive',
  http: 'green',
  verbose: 'teal',
  debug: 'blue',
  silly: 'violet',
}
const ColoredLabel = ({ label }) => {
  let [color, setColor] = useState('grey')

  useEffect(() => {
    setColor(labelColors[label])
  }, [])

  return (<Label color={color}>{label}</Label>)
}

const Device = props => {
  // states
  const [device, setDevice] = useState()
  const [deleteModal, setDeleteModal] = useState(false)
  const [successMessage, setSuccessMessage] = useState(false)
  const [backendErrMessage, setBackendErrMessage] = useState(false)
  const [paginateData, setPaginateData] = useState()
  const [activePage, setActivePage] = useState(1)
  const [logPage, setLogPage] = useState()
  const [logs, setLogs] = useState()
  const [pageInfo, setPageInfo] = useState()
  const [showResetModal, setShowResetModal] = useState(false)
  const [successReset, setSuccessReset] = useState(false)
  const [editSuccess, setEditSuccess] = useState(false)
  const [resetErrMessage, setResetErrMessage] = useState(false)

  // use params "device" as "id"
  let { device: id } = useParams()
  // query device
  const [getData, { refetch, loading: loadingDeviceData, called: calledDeviceData }] = useLazyQuery(DEVICE, {
    fetchPolicy: 'network-only',
    onCompleted: dataDev => {
      if (dataDev && dataDev.me && dataDev.me.device) {
        setDevice(dataDev.me.device)
        // set pagination data
        let entries = dataDev.me.device.connections
        let pages = _.chunk(entries, 10)
        pages = pages.map((page, i) => {
          let obscuredPage = page.map(ent => {
            let { ip, created_at, destroyed_at } = ent
            let duration
            if (created_at && destroyed_at) {
              // duration = moment(moment(destroyed_at).toDate() - moment(created_at).toDate()).format('HH:mm:ss')
              let hours = parseInt((moment(destroyed_at).toDate() - moment(created_at).toDate()) / (1000 * 60 * 60))
              let restH = (moment(destroyed_at).toDate() - moment(created_at).toDate()) % (1000 * 60 * 60)
              let mins = parseInt(restH / (1000 * 60))
              let restMins = restH % (1000 * 60)
              let secs = parseInt(restMins / 1000)
              duration = hours + ':' + ((mins < 10) ? ('0' + mins) : mins) + ':' + ((secs < 10) ? ('0' + secs) : secs)
            }
            if (created_at) created_at = moment(created_at).format('HH:mm:ss DD/MM/YYYY')
            if (destroyed_at) destroyed_at = moment(destroyed_at).format('HH:mm:ss DD/MM/YYYY')
            return { ip, created_at, destroyed_at, duration }
          })
          return {
            content: obscuredPage,
            page: i + 1,
            active: i === 0
          }
        })
        if (pages && pages.length > 0) setPaginateData(pages)
      }
    },
    onError: errDev => console.log(errDev)
  })

  useEffect(() => {
    if (props && props.match && props.match.params && props.match.params.device) {
      getData({ variables: { id } })
    }
  }, [])

  // delete device
  const history = useHistory()
  const goToDevicesPage = () => history.push('/devices')
  const [deleteDevice] = useMutation(DELETE_DEVICE, {
    fetchPolicy: 'network-only',
    onCompleted: delData => {
      // hide comfirm modal
      setDeleteModal(false)
      let respData = delData.delete_device
      // backend error
      if (!respData) setBackendErrMessage(true)
      // set success message
      setSuccessMessage(true)
      setTimeout(() => {
        setSuccessMessage(false)
        goToDevicesPage()
      }, 3000)
    },
    onError: delErr => {
      setDeleteModal(false)
      setBackendErrMessage(true)
      setTimeout(() => {
        setBackendErrMessage(false)
        goToDevicesPage()
      }, 3000)
      console.log(delErr)
    }
  })

  const handleDeleteDevice = e => {
    e.preventDefault()
    deleteDevice({
      variables: { input: { id } }
    })
    setDeleteModal(false)
  }

  // reset tokens
  const [resetTokens] = useMutation(RESET_TOKENS, {
    fetchPolicy: 'network-only',
    onCompleted: resetData => {
      // hide comfirm modal
      setShowResetModal(false)
      let respData = resetData.reset_device_token
      // backend error
      if (!respData) setResetErrMessage(true)
      // set device provisioned to false
      let dev = _.cloneDeep(device)
      setDevice({ ...dev, provisioned: false })
      // set success message
      setSuccessReset(true)
      setTimeout(() => {
        setSuccessReset(false)
      }, 3000)
    },
    onError: resetErr => {
      setShowResetModal(false)
      setResetErrMessage(true)
      setTimeout(() => {
        setResetErrMessage(false)
      }, 3000)
      console.log(resetErr)
    }
  })

  const handleResetTokens = () => {
    resetTokens({
      variables: { input: { id } }
    })
  }

  // subscription device online
  let { loading: subLoading, error: subError, data: subData } = useSubscription(ONLINE_SUBSCRIPTION)
  useEffect(() => {
    if (device && !subLoading && subData && subData.device_online) {
      let { device_id, online } = subData.device_online
      let updatedDevice = { ...device }
      if (updatedDevice.id === device_id) updatedDevice.online = online
      setDevice(updatedDevice)
      // update connections list && logs
      getData({ variables: { id } })
      setLogPage(1)
      getLogs({
        variables: {
          id,
          page: 1
        }
      })
    }
    if (subError) console.log(subError)
  }, [subData])

  const handlePaginationChange = (e, { activePage: pageChange }) => setActivePage(pageChange)

  // logs
  const [getLogs, { loading: loadingLogsData, called: calledLogsData }] = useLazyQuery(DEVICE_LOG, {
    fetchPolicy: 'network-only',
    onCompleted: logsData => {
      if (logsData &&
          logsData.me &&
          logsData.me.device &&
          logsData.me.device.logs &&
          logsData.me.device.logs.edges &&
          logsData.me.device.logs.edges.length > 0) {
        setLogs(logsData.me.device.logs.edges)
      }
      if (
        logsData &&
        logsData.me &&
        logsData.me.device.logs &&
        logsData.me.device.logs.total_pages &&
        logsData.me.device.logs.page_info
      ) {
        setPageInfo({
          totalPages: logsData.me.device.logs.total_pages
        })
      }
    },
    onError: logsError => {
      console.log(logsError)
    }
  })

  useEffect(() => {
    if (device) {
      setLogPage(1)
    }
  }, [device])

  useEffect(() => {
    if (logPage) {
      setLogs([])
      getLogs({
        variables: {
          id,
          page: logPage
        }
      })
    }
  }, [logPage])

  const handlePaginateLogs = (e, { activePage: pageChange }) => setLogPage(pageChange)

  // update device
  const [updateDeviceMutation] = useMutation(UPDATE_DEVICE, {
    fetchPolicy: 'network-only',
    onCompleted: upDevData => {
      // hide comfirm modal
      setDeleteModal(false)
      let respData = upDevData.update_device
      // set success message
      setEditSuccess(true)
      setTimeout(() => {
        setEditSuccess(false)
      }, 3000)
      // backend error
      if (!respData) setBackendErrMessage(true)
      setTimeout(() => {
        setBackendErrMessage(false)
      }, 3000)
    },
    onError: upDevErr => {
      setBackendErrMessage(true)
      setTimeout(() => {
        setBackendErrMessage(false)
      }, 3000)
      console.log(upDevErr)
    }
  })
  // update device handler

  const updateDevice = ({field, value}) => {
    let update = {}
    if (field === 'purchased_at') {
      update.purchased_at = moment(value, 'YYYY-MM-DD').toISOString()
    } else if (field.startsWith('meta.')) {
      const metaField = field.replace('meta.', '')
      update.meta = update.meta || {}
      update.meta[metaField] = value
    } else {
      update[field] = value
    }
    // set State
    setDevice(device => ({
      ...device,
      ...update
    }))
  }
  const handleUpdateDevice = () => {
    let { id, purchased_at, po_number, description, meta } = device
    updateDeviceMutation({
      variables: { input: {
        id, purchased_at, po_number, description, meta
      }}
    })
  }

  // date input fix
  const handleDateInputLayout = e => {
    if (e.target.value && e.target.value !== '') {
      e.target.className = 'not_empty'
    } else {
      e.target.className = ''
    }
  }

  return (
    <>
      <Container className='Device'>
        <Header as='h3' floated='left'>
          <Icon name='computer' />
          <Header.Content>
            Device
            <Header.Subheader>Details:</Header.Subheader>
          </Header.Content>
        </Header>

        {loadingDeviceData && calledDeviceData && (<Dimmer active inverted><Loader active>Loading device data...</Loader></Dimmer>)}

        {!loadingDeviceData && (
          <>
            {device && (
              <Header floated='right'>
                <Icon
                  className='card-icon'
                  name='circle'
                  color={device.online ? 'green' : 'red'}
                />
                {device.online ? 'online' : 'offline'}
              </Header>
            )}
            {device && (
              <Header floated='right'>
                <Button
                  negative
                  onClick={() => setDeleteModal(true)}
                >
                  <Icon name='trash alternate' /> DELETE
                </Button>
              </Header>
            )}
            {backendErrMessage && (
              <Message
                negative
                size='small'
                onDismiss={() => setBackendErrMessage(false)}
              >
                <Message.Header>Failed to delete device!</Message.Header>
                <p>Backend refused to delete this device!</p>
              </Message>
            )}
            {successMessage && (
              <Message
                positive
                size='small'
              >
                <Message.Header>Success!</Message.Header>
                <p>Device has been successfully deleted!</p>
              </Message>
            )}
            {resetErrMessage && (
              <Message
                negative
                size='small'
                onDismiss={() => setResetErrMessage(false)}
              >
                <Message.Header>Failed to delete tokens!</Message.Header>
                <p>Backend refused to delete tokens for this device!</p>
              </Message>
            )}
            {successReset && (
              <Message
                positive
                size='small'
              >
                <Message.Header>Success!</Message.Header>
                <p>Tokens has been successfully reseted!</p>
              </Message>
            )}
            {editSuccess && (
              <Message
                positive
                size='small'
              >
                <Message.Header>Success!</Message.Header>
                <p>Device successfully edited!</p>
              </Message>
            )}
            <br />
            {device && (
              <Grid columns='equal' reversed='mobile vertically' style={{width: '100%', marginBottom: '1rem'}}>
                <Grid.Column>
                  <Table celled striped>
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell collapsing><b>PO NUMBER</b></Table.Cell>
                        <Table.Cell>
                          <Input
                            type='text'
                            value={(device.po_number) ? device.po_number : ''}
                            onChange={(e, {value}) => updateDevice({field: 'po_number', value})}
                          />
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell collapsing><b>PURCHASED AT</b></Table.Cell>
                        <Table.Cell>
                          <Input
                            className={device.purchased_at === '' ? 'date-input' : ''}
                            type='date'
                            placeholder='DD/MM/YYYY'
                            value={(device.purchased_at) ? moment(device.purchased_at).format('YYYY-MM-DD') : ''}
                            onChange={(e, {value}) => {
                              handleDateInputLayout(e)
                              updateDevice({field: 'purchased_at', value})
                            }}
                          />
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell collapsing><b>DESCRIPTION</b></Table.Cell>
                        <Table.Cell>
                          <Input
                            type='text'
                            value={(device.description) ? device.description : ''}
                            onChange={(e, {value}) => updateDevice({field: 'description', value})}
                          />
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell collapsing><b>TAG</b></Table.Cell>
                        <Table.Cell>
                          <Input
                            type='text'
                            value={(device.meta.tag) ? device.meta.tag : ''}
                            onChange={(e, {value}) => updateDevice({field: 'meta.tag', value})}
                          />
                        </Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                  <Button
                    primary
                    onClick={handleUpdateDevice}
                  >save changes</Button>
                </Grid.Column>
                <Grid.Column>
                  <Table celled striped>
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell collapsing><b>SERIAL</b></Table.Cell>
                        <Table.Cell>{(device.serial) ? device.serial : ''}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell collapsing><b>NAME</b></Table.Cell>
                        <Table.Cell>{(device.name) ? device.name : ''}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell collapsing><b>MODEL</b></Table.Cell>
                        <Table.Cell>{(device.model) ? device.model : ''}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell collapsing><b>ENABLED</b></Table.Cell>
                        <Table.Cell>{(device.enabled) && device.enabled ? 'ENABLED' : 'DISABLED'}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell collapsing><b>CREATED AT</b></Table.Cell>
                        <Table.Cell>{(device.created_at) ? moment(device.created_at).format('DD MMM YYYY') : ''}</Table.Cell>
                      </Table.Row>
                      {device.meta && device.meta.os && device.meta.os.name && (
                        <Table.Row>
                          <Table.Cell collapsing><b>OS NAME</b></Table.Cell>
                          <Table.Cell>{device.meta.os.name}</Table.Cell>
                        </Table.Row>
                      )}
                      {device.meta && device.meta.os && device.meta.os.version && (
                        <Table.Row>
                          <Table.Cell collapsing><b>OS VERSION</b></Table.Cell>
                          <Table.Cell>{device.meta.os.version}</Table.Cell>
                        </Table.Row>
                      )}
                      {device.meta && device.meta.zerotier && (
                        <>
                          <Table.Row>
                            <Table.Cell collapsing><b>ZEROTIER ID</b></Table.Cell>
                            <Table.Cell>
                              {
                                (typeof device.meta.zerotier) === 'string' ? device.meta.zerotier :
                                (typeof device.meta.zerotier) === 'object' ? `${device.meta.zerotier.id}`
                                : 'unsupported data type'
                              }
                            </Table.Cell>
                          </Table.Row>
                          {device.meta.zerotier.ip && (
                            <Table.Row>
                              <Table.Cell collapsing><b>ZEROTIER IP</b></Table.Cell>
                              <Table.Cell>
                                {device.meta.zerotier.ip}
                              </Table.Cell>
                            </Table.Row>
                          )}
                          {device.meta.zerotier.network && (
                            <Table.Row>
                              <Table.Cell collapsing><b>ZEROTIER NETWORK</b></Table.Cell>
                              <Table.Cell>
                                {device.meta.zerotier.network}
                              </Table.Cell>
                            </Table.Row>
                          )}
                        </>
                      )}
                      {device.meta && device.meta.ip && (
                        <Table.Row>
                          <Table.Cell collapsing><b>INTERNAL IP</b></Table.Cell>
                          <Table.Cell>{device.meta.ip}</Table.Cell>
                        </Table.Row>
                      )}
                      {device.research && (
                        <Table.Row>
                          <Table.Cell collapsing><b>RESEARCH</b></Table.Cell>
                          <Table.Cell>{device.research ? 'TRUE' : 'FALSE'}</Table.Cell>
                        </Table.Row>
                      )}
                    </Table.Body>
                  </Table>
                </Grid.Column>
              </Grid>
            )}
            {device && device.enabled && (
              <>
                <p>Device connection history:</p>
                <Table
                  celled
                  fixed
                >
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>
                        IP address:
                      </Table.HeaderCell>
                      <Table.HeaderCell>
                        Connected At:
                      </Table.HeaderCell>
                      <Table.HeaderCell>
                        Disconnected At:
                      </Table.HeaderCell>
                      <Table.HeaderCell>
                        Duration:
                      </Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {device.connections && activePage && paginateData && paginateData[activePage - 1].content.map((entrie, i) => (
                      <Table.Row key={i}>
                        <Table.Cell>{entrie.ip}</Table.Cell>
                        <Table.Cell>{entrie.created_at}</Table.Cell>
                        <Table.Cell>{entrie.destroyed_at}</Table.Cell>
                        <Table.Cell>{entrie.duration}</Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                  {device.connections && paginateData && paginateData.length > 1 && (
                    <Table.Footer>
                      <Table.Row>
                        <Table.HeaderCell colSpan='4'>
                          <Pagination
                            activePage={activePage}
                            totalPages={paginateData && paginateData.length}
                            firstItem={false}
                            lastItem={false}
                            onPageChange={handlePaginationChange}
                            siblingRange={0}
                          />
                        </Table.HeaderCell>
                      </Table.Row>
                    </Table.Footer>
                  )}
                </Table>
                {/* Logs */}
                {loadingLogsData && calledLogsData && (<Dimmer active inverted><Loader active>Loading logs...</Loader></Dimmer>)}
                {!logs && !loadingLogsData && (
                  <>
                    <p>Logs:</p>
                    <p>No logs yet.</p>
                  </>
                )}
                {logs && !loadingLogsData && (
                  <>
                    <p>Logs:</p>
                    <Table celled striped>
                      <Table.Header>
                        <Table.Row>
                          <Table.HeaderCell>Level</Table.HeaderCell>
                          <Table.HeaderCell>Label</Table.HeaderCell>
                          <Table.HeaderCell>Event / Message</Table.HeaderCell>
                          <Table.HeaderCell>Created At</Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        {logs && logs.map((log, i) => (
                          <Table.Row key={i}>
                            <Table.Cell>
                              {(log.node.level && (
                                <ColoredLabel label={log.node.level} />
                              )) || ''}
                            </Table.Cell>
                            <Table.Cell>{log.node.label || ''}</Table.Cell>
                            <Table.Cell>{((log.node.event || log.node.message) && (
                              <>
                                <strong>
                                  {log.node.event}
                                  {log.node.event && log.node.message && ': '}
                                </strong>
                                  {log.node.message}
                              </>
                            )) || ''}
                            </Table.Cell>
                            <Table.Cell>
                              {
                                log.node.created_at ?
                                  moment(log.node.created_at).format('HH:mm:ss DD/MM/YYYY') :
                                  ''
                              }
                            </Table.Cell>
                          </Table.Row>
                        ))}
                      </Table.Body>
                      {pageInfo && pageInfo.totalPages && pageInfo.totalPages > 1 && (
                        <Table.Footer>
                          <Table.Row>
                            <Table.HeaderCell colSpan='4'>
                              <Pagination
                                activePage={logPage}
                                totalPages={pageInfo.totalPages}
                                firstItem={false}
                                lastItem={false}
                                onPageChange={handlePaginateLogs}
                                siblingRange={0}
                              />
                            </Table.HeaderCell>
                          </Table.Row>
                        </Table.Footer>
                      )}
                    </Table>
                  </>
                )}
              </>
            )}
            {device && device.provisioned && (
              <>
                <Button
                  color='red'
                  onClick={() => setShowResetModal(true)}
                >
                  Reset Device Tokens
                </Button>
                <br/><br/>
              </>
            )}
          </>
        )}
      </Container>
      <Modal
        basic
        onClose={() => setDeleteModal(false)}
        onOpen={() => setDeleteModal(true)}
        open={deleteModal}
        size='small'
      >
        <Header icon>
          <Icon name='trash' />
          Are you sure you want to delete device?
        </Header>
        <Modal.Actions>
          <Button basic color='red' inverted onClick={() => setDeleteModal(false)}>
            <Icon name='remove' /> No
          </Button>
          <Button color='green' inverted onClick={handleDeleteDevice}>
            <Icon name='checkmark' /> Yes
          </Button>
        </Modal.Actions>
      </Modal>
      {/* reset tokens confirmation modal */}
      <Modal
        basic
        onClose={() => setShowResetModal(false)}
        onOpen={() => setShowResetModal(true)}
        open={showResetModal}
        size='small'
      >
        <Header icon>
          <Icon name='warning' />
          Are you sure you want to reset all tokens for this device?
        </Header>
        <Modal.Actions>
          <Button basic color='green' inverted onClick={() => setShowResetModal(false)}>
            <Icon name='remove' /> No
          </Button>
          <Button color='red' inverted onClick={handleResetTokens}>
            <Icon name='checkmark' /> Yes
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  )
}

export default Device
